var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkpoint-level-dropdown-cell",attrs:{"data-testid":"checkpoint-level-dropdown-cell"}},[_c(_setup.CheckpointLevelBanner,{attrs:{"level":_vm.level,"disabled":_vm.disabled},on:{"change":_setup.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }